import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tagged_text = _resolveComponent("tagged-text");
  const _component_slot_parent_value = _resolveComponent("slot-parent-value");
  return _openBlock(), _createBlock(_component_slot_parent_value, {
    image: $props.value.image,
    collapsed: $props.collapsed,
    onToggleChildren: _cache[0] || (_cache[0] = $event => _ctx.$emit('toggleChildren')),
    image_overlays: $props.image_overlays,
    image_max_size: $props.value.image_size,
    noArrow: $props.noArrow
  }, _createSlots({
    default: _withCtx(() => [$props.tagged ? (_openBlock(), _createBlock(_component_tagged_text, {
      key: 0
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.value.brand ?? 'Unbranded'), 1)]),
      _: 1
    })) : _createCommentVNode("", true), $props.custom ? _renderSlot(_ctx.$slots, "custom", {
      key: 1
    }) : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.value.brand ?? 'Unbranded'), 1))]),
    _: 2
  }, [_ctx.$slots['badge'] ? {
    name: "badge",
    fn: _withCtx(() => [_renderSlot(_ctx.$slots, "badge")]),
    key: "0"
  } : undefined]), 1032, ["image", "collapsed", "image_overlays", "image_max_size", "noArrow"]);
}